// import http from '../../services/http'
import httpAuth from "../../services/httpAuth";

import getErrorMessage from "../../helpers/getErrorMessage.helper";
import {
  getSignUpSuccess,
  getSignUpError,
  setPromoListStore,
  setAffCode,
} from "./signUp.slice";
import axios from "axios";
import { BASE_DEV_URL, BASE_VERIFY_OTP_URL } from "../../config/api.config";
import httpNotAuth from "../../services/httpNotAuth";
import {
  getAffiliateCodeError,
  getAffiliateCodeSuccess,
} from "./affiliate.slice";
import { toastr } from "react-redux-toastr";
import { requestLogout } from "../auth/auth.thunks";

// export const registerNew = (data) => async (dispatch) => {
//   try {
//     const response = await httpAuth.post("/user/register", data);
//     // const response = await axios.post( BASE_VERIFY_OTP_URL + '/auth/verifyOtp', data)
//     if (response.data.success) {
//       console.log(response.data.success);
//       console.log(response);
//       // token = response.headers.authorization
//     }
//     return response;
//   } catch (e) {
//     const errorMsg = getErrorMessage(e);
//     throw errorMsg;
//   }
// };
export const registerNew = (data) => async (dispatch) => {
  try {
    const response = await httpAuth.post("/user/registerShoutpe", data);
    // const response = await axios.post( BASE_VERIFY_OTP_URL + '/auth/verifyOtp', data)
    if (response.data.success) {
      console.log(response.data.success);
      console.log(response);
      // token = response.headers.authorization
    }
    return response;
  } catch (e) {
    const errorMsg = getErrorMessage(e);
    throw errorMsg;
  }
};

export const postNumberSignUp = (data) => async (dispatch) => {
  try {
    const response = await httpNotAuth.post("whatsapp/send-code", data);
    // console.log('__res: ', response)

    if (response.data.status) {
      // dispatch(getSignUpSuccess(response.data.success))
    }
    return response;
  } catch (e) {
    console.log("e: ", e);
    dispatch(getSignUpError());
    const errorMsg = getErrorMessage(e);
    throw errorMsg;
  }
};

export const VerifyRefferalCode = (data) => async (dispatch) => {
  try {
    const response = await httpAuth.post("verifyRefferalCode", data);
    return response;
    // console.log('verify response: ', response)
  } catch (e) {
    const errorMsg = getErrorMessage(e);
    throw errorMsg;
  }
};

export const CreateUserOTP = (data) => async (dispatch) => {
  try {
    // const response = await httpAuth.post('/auth/verifyOtp', data)
    const response = await httpNotAuth.post("createUserOtp/", data);
    if (response.data.success) {
      // console.log("Success Response: ", response.data.success);
      // console.log(response);
      // token = response.headers.authorization
    }
    return response;
  } catch (e) {
    const errorMsg = getErrorMessage(e);
    throw errorMsg;
  }
};

export const resendOTP = (data) => async (dispatch) => {
  try {
    const response = await httpAuth.post("whatsapp/re-send", data);
    if (response.data.status) {
      console.log(response.data);
    }
    return response;
  } catch (e) {
    const errorMsg = getErrorMessage(e);
    throw errorMsg;
  }
};

export const verifyOTP = (data) => async (dispatch) => {
  try {
    const response = await httpAuth.post("whatsapp/verify", data);
    return response;
  } catch (e) {
    const errorMsg = getErrorMessage(e);
    throw errorMsg;
  }
};

export const postCheckPromo = (memberCode, token, data) => async (dispatch) => {
  // const memberCode = getState().user.memberCode;
  console.log("token in req", token);
  try {
    const response = await axios.post(
      BASE_DEV_URL + `/account/${memberCode}/promotions/promo-code`,
      data,
      {
        headers: {
          Authorization: `${token}`,
        },
      },
    );
    if (response.data.success) {
      console.log(response.data.success);
    }
    return response;
  } catch (e) {
    const errorMsg = getErrorMessage(e);
    throw errorMsg;
  }
};

export const getPromotionsList = () => async (dispatch) => {
  try {
    const response = await httpAuth.get("/promotions");
    if (response.data.success) {
      dispatch(getSignUpSuccess(response.data.result));
      console.log(response.data.success);
      // if(response?.data?.result.length){
      // }
    }
    return response;
  } catch (e) {
    const errorMsg = getErrorMessage(e);
    throw errorMsg;
  }
};

export const forgotPasswordOtp = (data) => async (dispatch) => {
  try {
    const response = await httpNotAuth.post("whatsapp/resetPassword", data);
    // console.log('__res: ', response)

    if (response.data.status) {
      // dispatch(getSignUpSuccess(response.data.success))
    }
    return response;
  } catch (e) {
    console.log("e: ", e);
    dispatch(getSignUpError());
    const errorMsg = getErrorMessage(e);
    throw errorMsg;
  }
};

export const resendForgotOTP = (data) => async (dispatch) => {
  try {
    const response = await httpAuth.post(
      "whatsapp/resendResetPasswordOtp",
      data,
    );
    if (response.data.status) {
      console.log(response.data);
    }
    return response;
  } catch (e) {
    const errorMsg = getErrorMessage(e);
    throw errorMsg;
  }
};

export const verifyForgotOTP = (data) => async (dispatch) => {
  try {
    const response = await httpAuth.post(
      "whatsapp/verifyResetPasswordOtp",
      data,
    );
    return response;
  } catch (e) {
    const errorMsg = getErrorMessage(e);
    throw errorMsg;
  }
};

export const resetPassword = (data) => async (dispatch) => {
  try {
    const response = await httpAuth.post("whatsapp/setPassword", data);
    return response;
  } catch (e) {
    const errorMsg = getErrorMessage(e);
    throw errorMsg;
  }
};

export const registerAffiliate = (data) => async (dispatch) => {
  try {
    const response = await httpAuth.post("/user/registerAffiliateUser", data);
    return response;
  } catch (e) {
    const errorMsg = getErrorMessage(e);
    throw errorMsg;
  }
};
export const getAffUserCount = (data) => async (dispatch) => {
  try {
    const response = await httpAuth.post("/report/getAffUserCount", data);
    return response;
  } catch (e) {
    const errorMsg = getErrorMessage(e);
    throw errorMsg;
  }
};

export const getLast5AffComm = (data) => async (dispatch) => {
  try {
    const response = await httpAuth.post("/report/getLast5AffComm", data);
    return response;
  } catch (e) {
    const errorMsg = getErrorMessage(e);
    throw errorMsg;
  }
};

export const getAffUserTodayPL = (data) => async (dispatch) => {
  try {
    const response = await httpAuth.post("/report/getAffUserTodayPL", data);
    return response;
  } catch (e) {
    const errorMsg = getErrorMessage(e);
    throw errorMsg;
  }
};
export const getAffUsersList = (data) => async (dispatch) => {
  try {
    const response = await httpAuth.post("/report/getAffUsersList", data);
    return response;
  } catch (e) {
    const errorMsg = getErrorMessage(e);
    throw errorMsg;
  }
};

export const getUserAffCode = (data) => async (dispatch) => {
  try {
    const response = await httpAuth.post("/report/getUserAffCode", data);

    if (response.data.status) {
      dispatch(getAffiliateCodeSuccess(response.data.data));
    }

    return response;
  } catch (e) {
    dispatch(getAffiliateCodeError());
  }
};

export const getTop5LossUsers = (data) => async (dispatch) => {
  try {
    const response = await httpAuth.post("/report/getTop5LossUsers", data);

    return response;
  } catch (e) {
    const errorMsg = getErrorMessage(e);
    throw errorMsg;
  }
};
export const getAffUserSportWisePL = (data) => async (dispatch) => {
  try {
    const response = await httpAuth.post("/report/getAffUserSportWisePL", data);

    return response;
  } catch (e) {
    const errorMsg = getErrorMessage(e);
    throw errorMsg;
  }
};
export const getAffUserCreatedCountDateWise = (data) => async (dispatch) => {
  try {
    const response = await httpAuth.post(
      "/report/getAffUserCreatedCountDateWise",
      data,
    );

    return response;
  } catch (e) {
    const errorMsg = getErrorMessage(e);
    throw errorMsg;
  }
};
export const getMyAffComm = (data) => async (dispatch) => {
  try {
    const response = await httpAuth.post("/report/getMyAffComm", data);

    return response;
  } catch (e) {
    const errorMsg = getErrorMessage(e);
    throw errorMsg;
  }
};

export const getAffSpecificUserSportWisePL = (data) => async (dispatch) => {
  try {
    const response = await httpAuth.post(
      "/report/getAffSpecificUserSportWisePL",
      data,
    );

    return response;
  } catch (e) {
    const errorMsg = getErrorMessage(e);
    throw errorMsg;
  }
};
export const getAffBonusSetting = (data) => async (dispatch) => {
  try {
    const response = await httpAuth.post("/report/getAffBonusSetting", data);

    return response;
  } catch (e) {
    const errorMsg = getErrorMessage(e);
    throw errorMsg;
  }
};
